import { CONDENSED, FULL } from '@/helpers/constants'
import { rfqQuoteTypes } from '@/data/rfq-quote-types'

export default {
	data() {
    return {
      CONDENSED: CONDENSED,
      FULL: FULL,
      rfqTypes: [
        { label: 'Condensed', value: CONDENSED },
        { label: 'Full', value: FULL }
      ],
      stages: [
        { label: 'Preliminary', value: 'preliminary' },
        { label: 'Under Construction', value: 'under construction' }
      ]
    }
	},
  computed: {
    quoteTypes() {
      const productBrand = this?.rfq?.product_brand 
        ? this.rfq.product_brand
        : this.$route.params.productBrand
      return rfqQuoteTypes
        .filter(qt => qt.product_brand === productBrand)
    }
  },
  methods: {
    exitAddFinishing(item, itemIndex, save) {
      item.finishing_name = null; 
      this.addingFinishing.splice(this.addingFinishing.indexOf(itemIndex), 1)
      if (save) {
        this.updateItem({
          itemId: item.id, 
          data: { finishing_name: null }
        })
      }
    }
  }
}